export const INITIAL_STATE = {
    name: null,
    image_url: null,
    description: null,
    is_highlight: false,
    promotion_banners: [],
}

export const GET_FIELD_NAME = {
    name: 'Nama brand',
    image_url: 'Logo brand',
    description: 'Deskripsi brand',
}

export const FIELD_NAME_DETAIL = {
    ...GET_FIELD_NAME,
    is_highlight: 'Highlight brand pada hover menu brand',
    promotion_banners: 'Banner promo brand',
    promotion_title: 'Title promo',
    promotion_product_ids: 'Product list',
}

export const ITEM_FIELD_NAME_DETAIL = {
    desktop_image_url: 'Banner desktop',
    mobile_image_url: 'Banner mobile',
}
